import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserBlackListService from '../../../../services/UserBlackListService';
import { insertUpdateItems as insertUpdateObjectCollectionItems } from '../../../../../../common/reducers/objectCollection/reducer';

function* blackListByExecutorsSaga(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      UserBlackListService.getUserBlackListByExecutors,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateObjectCollectionItems(
            'usersModule.collections.userCollection',
            result.destructData.usersById
          )
        );
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds,
            pagination: result.destructData.pagination
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeLatest(
      sendRequest(reducerName).type,
      blackListByExecutorsSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/lists/sagas/blackListByExecutorsSaga.js